import axios from "axios";
import HOST_URL from "./utils/Url"; // adjust path if needed

// Set base URL globally
axios.defaults.baseURL = HOST_URL.HOST_URL2 || HOST_URL.HOST_URL;

// Attach token for every request
axios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: Handle 401 globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized! Redirecting to login...");
      sessionStorage.clear();
      window.location.href = "/"; // redirect to login page
    }
    return Promise.reject(error);
  }
);

export default axios;
